/**
 * Форматирует timestamp в читаемую дату
 * @param {number} timestamp - Unix timestamp в секундах
 * @returns {string} Дата в формате "ЧЧ:ММ ДД.ММ.ГГГГ"
 */
export function formatDate(timestamp) {
    const date = new Date(timestamp * 1000); // переводим в миллисекунды
    
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return `${hours}:${minutes} ${day}.${month}.${year}`;
}

// Вход: 1744865237 (число) - это  Timestamp -количество секунд, прошедших с 1 января 1970 года.
// Выход: "15:47 17.04.2025" (строка)
// padStart - метод строки, который добавляет символы в начало, пока строка не достигнет 
// нужной длины: Если бы было 5 часов - "05" (добавился ноль)
// Получение месяца - Особенность JS: Месяцы считаются с 0! (апрель - это 3, потому что январь = 0)